import type {ProductSelection, HospitalProduct, Nullable, ExtrasProduct} from '@nib/types-session-api';
import {IWHIJoinState} from '../../store';
import _get from 'lodash/get';

export const selectData = (state: IWHIJoinState): ProductSelection => _get(state, 'session.session.productSelection', {} as ProductSelection);

export const getHospital = (state: IWHIJoinState): HospitalProduct => selectData(state).hospital || {};
export const getExtras = (state: IWHIJoinState): ExtrasProduct => selectData(state).extras || {};
export const getHospitalId = (state: IWHIJoinState): Nullable<number> => getHospital(state).id;
export const getExtrasId = (state: IWHIJoinState): Nullable<number> => getExtras(state).id;
